import './header.less';
import React, {Proptypes} from 'react';
import FixedHeader from './fixed_header';
import ResponsiveHeader from './responsive_header';

const MediaQuery = require('react-responsive');


export default class Header extends React.Component{
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render(){
    const {props, state} = this;
    return(
      <header className="header">
        <MediaQuery query='(min-width: 768px)'>
          <div className="wrapper">
            { props && props.isFixedHeader && <FixedHeader /> }
          </div>
        </MediaQuery>
        <MediaQuery query='(max-width: 767px)'>
            <ResponsiveHeader logoImagePath = "../public/images/landing/awb_logo.png" iconClassName = "landing-page-menu-icon icon-three-bars" responsiveHeaderClassName = "landing-page-default-header" />
        </MediaQuery>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// app/header/header.jsx